module.exports = __webpack_public_path__ + "media/img/Landing_Page/S2U-Institution-BG-4bbbce5aea7519ff011a810399448a86.svg";